import { render, staticRenderFns } from "./GridRoles.vue?vue&type=template&id=089b0384&"
import script from "./GridRoles.vue?vue&type=script&lang=js&"
export * from "./GridRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('089b0384')) {
      api.createRecord('089b0384', component.options)
    } else {
      api.reload('089b0384', component.options)
    }
    module.hot.accept("./GridRoles.vue?vue&type=template&id=089b0384&", function () {
      api.rerender('089b0384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/roles/grid/GridRoles.vue"
export default component.exports